import React, { Component } from "react";
import DateTimeRenderer from "../cell-renderer/DateTimeRenderer";
import UserDisplay from "../UserDisplay";
import i18next from "i18next";
import { isHeaderQuestion, __getQuestionAndAnswer } from "../../_clearance/utils/utils";
import TextElementClearance from "../preview-element/TextElementClearance";

class TrackHistory extends Component {
    constructor(props) {
      super();
      this.state = {
      };
    }

    getHistView(t){
        const { 
          getStatus,  
          orgRuntime: {
            runtime: { _trackMusicOrigins: trackOrigins },
          },
        } = this.props;
        return <>
          <>
            { t?.changedFields?.length > 0 && (
              <ul>
                {t.changedFields.map(k=>{
                  switch(k){
                    case "trackTitle":
                    case "catNo":
                    case "isrc":
                    case "org_sky_Source":
                    case "recordLabel":
                    case "composer":
                    case "performer":
                    case "prs":
                    case "publisher":
                      return <li>{i18next.t(`history.fields.${k}`)} to {t?.track?.trackDetails[k] && Array.isArray(t?.track?.trackDetails[k])?t?.track?.trackDetails[k].join(", "):t?.track?.trackDetails[k]}</li>;
                    case "musicOrigin":
                      return <li>{i18next.t(`history.fields.${k}`)} to {trackOrigins[t?.track?.trackDetails[k]]?.label}</li>;
                    case 'clearancestatus':
                        return <li>{t?.track?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to 
                        { getStatus(t.track[k])?.id === 'notfound' ? (
                          <span> Clear Me</span>
                        ) : (
                          <span
                            class="clearanceValueLabel"
                            style={{
                              color: getStatus(t.track[k]).color,
                            }}
                          >
                            <div
                              style={{
                                background: getStatus(t.track[k]).color,
                              }}
                            ></div>
                            {getStatus(t.track[k]).name}
                          </span>
                        ) }
                        <span>{t?.track?.adminOverriddenWithNotes}</span></li>
                    default:
                      if(t.track[k] && t.track[k].length>0){
                        return <li>{t?.track?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to { Array.isArray(t.track[k])?(()=>" \r\n"+t.track[k].join(", "))():t.track[k] } {t?.track?.adminOverriddenWithNotes}</li>
                      }
                      else{
                        return "";
                      }
    
                  }
                })}
              </ul>
            ) }
          </>
        </>
      }

    getQuestions(t){
      const { classes } = this.props;
      return <div className={classes.historyQuestions}>
      {(
          (t?.clearance?.commits || [])[t.trackId]
            ?.next || []
        )
          .sort((a, b) => {
            if ( isHeaderQuestion(a) && isHeaderQuestion(b)
              
            )
              return 0;
            else if (
              isHeaderQuestion(a)
              
            )
              return -1;
            else return 1;
          })
          .map((v, i) => {
            let qa = __getQuestionAndAnswer(
              t?.clearance || {},
              v,
              t.trackId
            );
            return (
              <TextElementClearance
                label={qa.q}
                classes={classes}
                labelStyle={{
                  color: qa.h ? "#FFC116" : "#00DCFF",
                }}
                style={{
                  color: qa.h ? "#FFC116" : "#00DCFF",
                }}
                data={qa.a}
              />
            );
          })}
      </div>
    }
  
    render() {
      const { classes, data, showDetails, migrated } = this.props;
      
      return (
        <>
             { !migrated && data.map(d=>{
                if(d?.skyMigrated){
                  return <>
                    <div className={classes.historyItem}>
                      <p className={classes.userName}>{`${d.firstName} ${d.lastName}`}</p>
                      <p className={classes.changedDate}> <DateTimeRenderer data={d.dateCreated} /> </p>
                      <p className={classes.actionName}>{d.eventTypeDesc}</p>
                      <p className={classes.userName}>{`${d.trackTitle}`}</p>
                      {Boolean(d.trackId) && Boolean(d.action) && 
                        <ul>
                          { d.action.split(";;").map(d=>{
                            return <li>{d}</li>
                          }) }
                        </ul>
                      }
                    </div>
                  </>
                }
                else{
                  return <>
                  <div className={classes.historyItem}>
                      <p className={classes.userName}>
                          <UserDisplay userId={d.by} />
                      </p>
                      <p className={classes.changedDate}>
                          <DateTimeRenderer data={d.at} />
                      </p>
                      { d.track.adminOverridden && d.actionType !== 'create' ? (<p className={classes.actionName}>{i18next.t(`history.keys.override`)}</p>) : (<p className={classes.actionName}>Track {i18next.t(`history.keys.${d.actionType}`)}</p>) }
                      
                      <div className={classes.objectName}>
                          {this.getHistView(d)}
                      </div>
                      <div className={classes.objectName}>
                          { (showDetails && (((d?.clearance?.commits || [])[d.trackId]?.next || []).length !== 0 && !d.track.adminOverridden) && d.actionType !== 'create') && this.getQuestions(d)}
                      </div>
                      
                      </div>
                      </>
                }
                }) }
                {migrated && data.map(d=>{
                return <>
                  <div className={classes.historyItem}>
                    <p className={classes.userName}>{`${d.firstName} ${d.lastName}`}</p>
                    <p className={classes.changedDate}> <DateTimeRenderer data={d.dateCreated} /> </p>
                    <p className={classes.actionName}>{d.eventTypeDesc}</p>
                    <p className={classes.userName}>{`${d.trackTitle}`}</p>
                    {Boolean(d.trackId) && Boolean(d.action) && 
                      <ul>
                        { d.action.split(";;").map(d=>{
                          return <li>{d}</li>
                        }) }
                      </ul>
                    }
                  </div>
                </>})
                }
        </>
      );
    }
  }
  
export default TrackHistory;